import { BaseLooper } from "./BaseLooper";
import { ControllerLooper } from "./ControllerLooper";
import { ApplicationSchema } from "../schema/ApplicationSchema";
import { BaseTypeSchema } from "../schema/BaseTypeSchema";

export class ApplicationLooper extends BaseLooper
{
    private schema: ApplicationSchema;
    constructor(schema: ApplicationSchema)
    {
        super();
        this.schema = schema;
    }
    override getAll(callback: (schema: BaseTypeSchema) => void)
    {
        let ans: BaseTypeSchema[] = [];
        for (let i = 0; i < this.schema.controllers.length; i++)
        {
            const controller = this.schema.controllers[i];
            let builder = new ControllerLooper(controller);
            let types = builder.getAll(callback);
            if (types)
                ans.push(...types);
        }
        return ans;
    }
}